<template>
    <div>
        <vue-headful :title="$t('application_requests')" />
        <div class="flex ">

    <vs-button
                class="mr-2 reply_btn"
                @click="$router.go(-1)"
                radius
                icon="reply"
            ></vs-button>
         <vs-tabs>
      <vs-tab   @click="setPage({ my: true })"

                 :label="$t('my_application')">

      </vs-tab>
      <vs-tab  v-if="isModerator" @click="setPage({})" :label="$t('application_requests')">

      </vs-tab>
      <vs-tab   v-if="isModerator"  @click="setPage({ edit: true })"

                :label="$t('application_requests_edit')">

      </vs-tab>
         </vs-tabs>
        </div>
        <!-- <div class="flex items-center">

            <h3 v-if="!$route.query.edit">
                {{ $t("application_requests") }}
            </h3>
            <h3 v-else>{{ $t("application_requests_edit") }}</h3>
        </div> -->

        <div class="flex items-end mobile_wrap">
            <vs-input
                :label-placeholder="$t('search_in_title')"
                class="w-full"
                v-model="searchClub"
            ></vs-input>
            <vx-tooltip :text="$t('find')">
                <vs-button class="ml-0 lg:ml-2 mt-1 lg:mt-0" icon="search" @click="getRequests"></vs-button>
            </vx-tooltip>
            <vx-tooltip :text="$t('clear')" color="warning">
                <vs-button
                    @click="
                    searchClub = '';
                    getRequests();
                "
                    class="ml-2 mt-1 lg:mt-0"
                    color="warning"
                    icon="clear"
                ></vs-button>
            </vx-tooltip>

        </div>
        <h6 class="mt-4">{{ count }} {{ $t("resultss") }}</h6>

        <div class="mt-6">
            <div v-if="!$route.query.edit">
                <div v-for="(item, i) in requestData" :key="i">
                    <reg-card
                        :data_created="item.created.slice(0, 10)"
                        :logo="item.club_logo.path"
                        :data="item.created"
                        :statusReq="item.status.name"
                        :title="item.name"
                        :type="item.club_type.name"
                        :status="item.public_or_private"
                        :faculty="item.faculti"
                        :director="item.author"
                        :soclinks="item.social_links"
                        :description="item.description"
                        :color="item.color"
                        :comment="item.comment"
                        :my="$route.query.my"
                        :item="item"
                        @accept="accept(item)"
                        @cancel="cancel(item)"
                        @modification="cancel(item, true)"
                    />
                </div>
            </div>
            <div v-else>
                <div v-for="(item, i) in requestData" :key="i">
                    <edit-card
                        :logo="item.club_logo.path"
                        :data="item.created"
                        :statusReq="item.status.name"
                        :title="item.name"
                        :type="item.club_type.name"
                        :status="item.public_or_private"
                        :faculty="item.faculti"
                        :director="item.author"
                        :soclinks="item.social_links"
                        :description="item.description"
                        :logoOld="item.student_club.club_logo.path"
                        :titleOld="item.student_club.name"
                        :typeOld="item.student_club.club_type.name"
                        :statusOld="item.student_club.public_or_private"
                        :facultyOld="item.oldFaculti"
                        :directorOld="item.student_club.founder.student_profile"
                        :soclinksOld="item.student_club.social_links"
                        :descriptionOld="item.student_club.description"
                        :color="item.color"
                        @accept="accept(item)"
                        @cancel="cancel(item)"
                        @modification="cancel(item, true)"
                    />
                </div>
            </div>
            <div class="flex items-center justify-center">
                <vs-button
                    v-show="more"
                    id="button-load-more-posts"
                    class="vs-con-loading__container"
                    @click="getMoreRequests"
                    >{{ $t("upload_more") }}</vs-button
                >
            </div>

            <vs-prompt
                :title="dialogTitle"
                :buttons-hidden="true"
                :accept-text="$t('done')"
                :active.sync="dialog"
            >
                <vs-textarea
                    v-model="descCancel"
                    class="mt-2"
                    :label="$t('description')"
                ></vs-textarea>
                <div class="flex justify-end">
                    <vs-button @click="completeCancel">{{
                        $t("done")
                    }}</vs-button>
                </div>
            </vs-prompt>
        </div>
        <div class="mobile_dummy"></div>
    </div>
</template>

<script>
import RegCard from "./components/RegCard";
import EditCard from "./components/EditCard";
import { mapActions, mapGetters } from 'vuex'
export default {
    components: {
        RegCard,
        EditCard,
    },
    data() {
        return {
            selectedItem: {},
            dialog: false,
            typeCancel: "",
            requestData: [],
            descCancel: "",
            searchClub: "",
            modification: false,
            dialogTitle: "",
            count: 0,
            page: 1,
            more: true,
            rTypes: []
        };
    },
    async created() {
        await  this.getRequestsTypes()
        this.getRoles()
        this.getRequests();
    },
    computed: {
        ...mapGetters({
            isModerator: "studclubs/getModerator",
        }),
    },
    methods: {
        ...mapActions({
            getRoles: "studclubs/getRoles"
        }),
        setPage(query){
            this.$router.push({
                name: 'stud-clubs-regRequests',
                query: query,
            })
            setTimeout(() => {
                this.requestData = []
                this.getRequests();
            }, 100);

        },
        getColor(uid) {
            if (uid === "24997b4e-8603-4c2a-80e4-0366f0ef1f6f") {
                return "danger";
            } else if (uid === "985c9d72-73cc-4b04-8f7d-9d4c82e115d6") {
                return "success";
            } else if (uid === "b0035f20-febe-4a73-8956-b5cdf1ad4198") {
                return "primary";
            } else if (uid === "e8bc1597-01b1-4c67-8545-489caf126b80") {
                return "warning";
            }
        },
        async getMoreRequests() {
            this.$vs.loading({
                background: this.backgroundLoading,
                color: this.colorLoading,
                container: "#button-load-more-posts",
                scale: 0.45,
            });

            this.page += 1;
            await this.getRequests();
            this.$vs.loading.close("#button-load-more-posts > .con-vs-loading");
        },
        async getRequestsTypes(){
            this.rTypes = (await this.$http('student_clubs/student_club_request_types/')).data

        },
        async getRequests() {
            this.$vs.loading();
            let response;
            if (this.$route.query.my) {
                response = await this.$http.get(
                    `student_clubs/student_club_request/get_my_student_club_request/?page=${ this.page }&student_club_name=${ this.searchClub }`
                );
            } else {
                let type;
                // просто для edit or create
                for(let i = 0; i < this.rTypes.length; i++){
                    if (this.$route.query.edit && this.rTypes[i].code === 'EDIT') {
                        type = this.rTypes[i].uid
                        break;
                    } else if (!this.$route.query.edit && this.rTypes[i].code === 'CREATE') {
                        type = this.rTypes[1].uid
                        break;
                    }
                }
                response = await this.$http.get(
                    `student_clubs/student_club_request/?page=${ this.page }&request_type=${ type }&student_club_name=${ this.searchClub }`
                );
            }

            if (response.status === 200) {
                // this.requestData = response.data.results;
                this.count = response.data.count;

                response.data.results.forEach((el) => {
                    this.requestData.push(el);
                });
                if (!response.data.next) {
                    this.more = false;
                }
                this.requestData = this.requestData.map((item) => {
                    return {
                        faculti: item.faculty
                            .map(function (el) {
                                return el.name;
                            })
                            .toString(),
                        color: this.getColor(item.status.uid),
                        oldFaculti: item.student_club.faculty
                            .map(function (el) {
                                return el.name;
                            })
                            .toString(),
                        ...item,
                    };
                });
            }
            this.$vs.loading.close();
        },

        cancel(item, mod = false) {
            this.selectedItem = item;
            this.dialogTitle = mod
                ? this.$t("send_revision")
                : this.$t("reject_request");
            this.dialog = true;
            this.modification = mod;
        },
        async completeCancel() {
            this.$vs.loading();
            let status;
            if (this.modification) {
                status = "e8bc1597-01b1-4c67-8545-489caf126b80";
            } else {
                status = "24997b4e-8603-4c2a-80e4-0366f0ef1f6f";
            }
            const response = await this.$http.post(
                `student_clubs/student_club_request/approve_student_clubs/`,
                {
                    status,
                    request_uid: this.selectedItem.uid,
                    comment: this.descCancel,
                }
            );
            if (response.status === 200) {
                let idx = this.requestData.indexOf(this.selectedItem);
                this.requestData[idx].status = response.data.status;
                this.requestData[idx].color = this.getColor(
                    response.data.status.uid
                );
                this.requestData.slice(idx, 1);
                this.dialog = false;
            }
            this.$vs.loading.close();
        },
        async accept(item) {
            this.$vs.loading();
            const response = await this.$http.post(
                `student_clubs/student_club_request/approve_student_clubs/`,
                {
                    status: "985c9d72-73cc-4b04-8f7d-9d4c82e115d6",
                    request_uid: item.uid,
                }
            );
            if (response.status === 200) {
                let idx = this.requestData.indexOf(item);
                this.requestData[idx].status = response.data.status;
                this.requestData[idx].color = "success";
                this.requestData.slice(idx, 1);
            }
            this.$vs.loading.close();
        },
    },
};
</script>

<style lang="scss">
@media only screen and (max-width: 800px) {
    .reply_btn{
        min-width: 30px;
        max-height: 30px;
    }
    .mobile_wrap{
        flex-wrap: wrap;
    }
    .mobile_dummy{
        padding-top: 30px;
    }
}
</style>
